angular.module("KhNavbar").config(["$translateProvider", function ($translateProvider) {
    $translateProvider.translations('en', {
        user_settings: 'User',
        account: 'Account',
        logout: 'Logout',
        profile: 'Profile',
        edit_profile: 'Edit profile',
        view_profile: 'View profile'
    });
}]);